export const ValidationRegexp = {
  IS_NUMBER: /^[0-9]+$/,
  IS_ENGLISH: /^[a-zA-Z]+$/,
  IS_TRADITIONAL_CHINESE: /^[\u4E00-\u9FFF]+$/,
  IS_TRADITIONAL_CHINESE_AND_ENGLISH: /^[\u4E00-\u9FFFa-zA-Z]+$/,
  IS_PHONE_CARRIER_ID: /^\/[0-9A-Z.+-]{7}$/,
  IS_COMPANY_UNIFORM_NUMBER: /^[0-9]{8}$/,
  IS_EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  IS_CELLPHONE_TW: /^(9|09)[0-9]{8}$/,
  IS_CELLPHONE_HK: /^[4,5,6,7,8,9][0-9]{7}$/,
  IS_CELLPHONE_KR: /^(1|01)[0-9]{8}$|^(1|01)[0-9]{9}$/,
  IS_CELLPHONE_JP: /^0[1-9]0[0-9]{8}$/,
}

export const ValidationHomeName = {
  TRADITIONAL_CHINESE_MINIMUM_LENGTH: 2,
  TRADITIONAL_CHINESE_MAXIMUM_LENGTH: 5,
  ENGLISH_MINIMUM_LENGTH: 4,
  ENGLISH_MAXIMUM_LENGTH: 10,
}

export const ValidationCvsName = {
  TRADITIONAL_CHINESE_MINIMUM_LENGTH: 2,
  TRADITIONAL_CHINESE_MAXIMUM_LENGTH: 5,
  ENGLISH_MINIMUM_LENGTH: 4,
  ENGLISH_MAXIMUM_LENGTH: 10,
}

export const ValidationHomeAddress = {
  MAXIMUM_LENGTH: 100,
}

export const ValidationOrderNote = {
  MAXIMUM_LENGTH: 50,
}
